<template>
  <!-- 第五步：应用企业基本信息 -->
  <div class="enterpriseInfo">
    <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="175px"
        class="form-wrap"
    >
      <div class="flex">
        <el-form-item  label="申报单位营业执照：" prop="businessLicenseName" style="width:100%">
          <el-upload
              class="avatar-uploader"
              action="/service-center/api/v1/upload/file/single"
              :file-list="businessLicenseAttach"
              :disabled="disabled"
              list-type="picture-card"
              :headers="headers"
              :on-preview="handlePictureCardPreview"
              accept=".jpg,.jpeg,.png,..pdf, .JPG,.JPEG,.PBG,.GIF,.BMP,.PDF"
              :on-remove="(file,fileList)=>handleRemoveFile(file,fileList,'businessLicenseAttach')"
              :on-error="handleFileError"
              :on-success="(e)=>handleFileSuccess(e,'businessLicenseAttach')">
            <i class="el-icon-plus" v-if="!disabled"></i>
          </el-upload>
          <span class="red" v-if="businessLicenseAttach.length == 0">

          </span>
        </el-form-item>
      </div>
      <!-- 信用证明 -->
      <div class="flex">
        <el-form-item label="信用证明" prop="creditProofName" style="width:100%">
          <el-upload
              class="avatar-uploader"
              action="/service-center/api/v1/upload/file/single"
              :file-list="creditProofAttach"
              :headers="headers"
              :limit="5"
              :show-file-list="true"
              accept=".jpg,.jpeg,.png,.xlsx , .xls ,.docx,.dox,.pdf, .txt,.pptx , .JPG,.JPEG,.PBG,.GIF,.BMP,.PDF,.XLSX,.XLS ,.DOCX,.DOX ,.TXT , .PPTX"
              :on-remove="(file,fileList)=>handleRemoveFile(file,fileList,'creditProofAttach')"
              :on-error="handleFileError"
              :on-preview="handlePreview"
              :on-success="(e)=>handleFileSuccess(e,'creditProofAttach')"
          >
            <el-button size="small" type="primary" v-if="!disabled">上传附件</el-button>
          </el-upload>
<!--          <div v-for="(item,index) in creditProofAttach" class="file-list flex">-->
<!--            <span style="margin-right: 20px"> {{item.name}}</span>-->
<!--            <el-button size="mini" @click="openFile(item.path || item.url)">下载</el-button>-->
<!--          </div>-->
          <span class="red" v-if="creditProofAttach.length == 0">
            *在“信用中国”网站（www.creditchina.gov.cn）查询的“失信被执行人”及“国家企业信用信息公示系统”网站（www.gsxt.gov.cn）查询的“严重违法失信名单”的查询结果网页打印件并加盖公章
          </span>
        </el-form-item>
      </div>

      <!-- 纳税清单 -->
      <div class="flex">
        <el-form-item label="纳税清单" prop="taxListName" style="width:100%">
          <el-upload
              class="avatar-uploader"
              action="/service-center/api/v1/upload/file/single"
              :file-list="taxListAttach"
              :headers="headers"
              :limit="5"
              :show-file-list="true"
              accept=".jpg,.jpeg,.png,.xlsx , .xls ,.docx,.dox,.pdf, .txt,.pptx , .JPG,.JPEG,.PBG,.GIF,.BMP,.PDF,.XLSX,.XLS ,.DOCX,.DOX ,.TXT , .PPTX"
              :on-remove="(file,fileList)=>handleRemoveFile(file,fileList,'taxListAttach')"
              :on-error="handleFileError"
              :on-preview="handlePreview"
              :on-success="(e)=>handleFileSuccess(e,'taxListAttach')"
          >
            <el-button size="mini" type="primary" v-if="!disabled">上传附件</el-button>
          </el-upload>
<!--          <div v-for="(item,index) in taxListAttach" class="file-list flex">-->
<!--            <span style="margin-right: 20px"> {{item.name}}</span>-->
<!--            <el-button size="mini" @click="openFile(item.path || item.url)">下载</el-button>-->
<!--          </div>-->
          <span class="red" v-if="taxListAttach.length == 0">
            *上一年度的纳税清单或清缴证明
          </span>
        </el-form-item>
      </div>

      <!-- 财务报表 -->
      <div class="flex">
        <el-form-item label="财务报表" prop="financialReportName" style="width:100%">
          <el-upload
              class="avatar-uploader"
              action="/service-center/api/v1/upload/file/single"
              :file-list="financialReportAttach"
              :headers="headers"
              :limit="5"
              :show-file-list="true"
              accept=".jpg,.jpeg,.png,.xlsx , .xls ,.docx,.dox,.pdf, .txt,.pptx , .JPG,.JPEG,.PBG,.GIF,.BMP,.PDF,.XLSX,.XLS ,.DOCX,.DOX ,.TXT , .PPTX"
              :on-remove="(file,fileList)=>handleRemoveFile(file,fileList,'financialReportAttach')"
              :on-error="handleFileError"
              :on-preview="handlePreview"
              :on-success="(e)=>handleFileSuccess(e,'financialReportAttach')"
          >
            <el-button size="small" type="primary" v-if="!disabled">上传附件</el-button>
          </el-upload>
<!--          <div v-for="(item,index) in financialReportAttach"class="file-list flex">-->
<!--            <span style="margin-right: 20px"> {{item.name}}</span>-->
<!--            <el-button size="mini" @click="openFile(item.path || item.url)">下载</el-button>-->
<!--          </div>-->
          <span class="red" v-if="financialReportAttach.length == 0">
            *企业近三年的财务报表
          </span>
        </el-form-item>
      </div>

      <!-- 服务佐证材料 -->
      <div class="flex">
        <el-form-item label="服务佐证材料" prop="serviceSupportName" style="width:100%">
          <el-upload
              class="avatar-uploader"
              action="/service-center/api/v1/upload/file/single"
              :file-list="serviceSupportAttach"
              :limit="5"
              :headers="headers"
              :show-file-list="true"
              accept=".jpg,.jpeg,.png,.xlsx , .xls ,.docx,.dox,.pdf, .txt,.pptx , .JPG,.JPEG,.PBG,.GIF,.BMP,.PDF,.XLSX,.XLS ,.DOCX,.DOX ,.TXT , .PPTX"
              :on-remove="(file,fileList)=>handleRemoveFile(file,fileList,'serviceSupportAttach')"
              :on-error="handleFileError"
              :on-preview="handlePreview"
              :on-success="(e)=>handleFileSuccess(e,'serviceSupportAttach')"
          >
            <el-button size="small" type="primary" v-if="!disabled">上传附件</el-button>
          </el-upload>
<!--          <div v-for="(item,index) in serviceSupportAttach" class="file-list flex">-->
<!--            <span style="margin-right: 20px"> {{item.name}}</span>-->
<!--            <el-button size="mini" @click="openFile(item.path || item.url)">下载</el-button>-->
<!--          </div>-->
          <span class="red" v-if="serviceSupportAttach.length == 0">
            *服务宁夏企业的相关佐证材料（提供合同、用户报告或应用证明等）
          </span>
        </el-form-item>
      </div>

      <!-- 获奖证书 -->
      <div class="flex">
        <el-form-item label="获奖证书" prop="awardCertificateName" style="width:100%">
          <el-upload
              class="avatar-uploader"
              action="/service-center/api/v1/upload/file/single"
              :file-list="awardCertificateAttach"
              :limit="5"
              :headers="headers"
              :show-file-list="true"
              accept=".jpg,.jpeg,.png,.xlsx , .xls ,.docx,.dox,.pdf, .txt,.pptx , .JPG,.JPEG,.PBG,.GIF,.BMP,.PDF,.XLSX,.XLS ,.DOCX,.DOX ,.TXT , .PPTX"
              :on-remove="(file,fileList)=>handleRemoveFile(file,fileList,'awardCertificateAttach')"
              :on-error="handleFileError"
              :on-preview="handlePreview"
              :on-success="(e)=>handleFileSuccess(e,'awardCertificateAttach')"
          >
            <el-button size="small" type="primary" v-if="!disabled">上传附件</el-button>
          </el-upload>
<!--          <div v-for="(item,index) in awardCertificateAttach" class="file-list flex">-->
<!--            <span style="margin-right: 20px"> {{item.name}}</span>-->
<!--            <el-button size="mini" @click="openFile(item.path || item.url)">下载</el-button>-->
<!--          </div>-->
          <span class="red" v-if="awardCertificateAttach.length == 0">
            *单位资质证明材料及获奖证书
          </span>
        </el-form-item>
      </div>

      <!-- 科研成果 -->
      <div class="flex">
        <el-form-item label="科研成果" prop="achievementName" style="width:100%">
          <el-upload
              class="avatar-uploader"
              action="/service-center/api/v1/upload/file/single"
              :file-list="achievementAttach"
              :limit="5"
              :headers="headers"
              :show-file-list="true"
              accept=".jpg,.jpeg,.png,.xlsx , .xls ,.docx,.dox,.pdf, .txt,.pptx , .JPG,.JPEG,.PBG,.GIF,.BMP,.PDF,.XLSX,.XLS ,.DOCX,.DOX ,.TXT , .PPTX"
              :on-remove="(file,fileList)=>handleRemoveFile(file,fileList,'achievementAttach')"
              :on-error="handleFileError"
              :on-preview="handlePreview"
              :on-success="(e)=>handleFileSuccess(e,'achievementAttach')"
          >
            <el-button size="small" type="primary" v-if="!disabled">上传附件</el-button>
          </el-upload>
<!--          <div v-for="(item,index) in achievementAttach" class="file-list flex">-->
<!--            <span style="margin-right: 20px"> {{item.name}}</span>-->
<!--            <el-button size="mini" @click="openFile(item.path || item.url)">下载</el-button>-->
<!--          </div>-->
          <span class="red" v-if="achievementAttach.length == 0">
            *研成果证明文件（包含专利、软件著作权及标准等）
          </span>
        </el-form-item>
      </div>

      <!-- 其他材料 -->
      <div class="flex">
        <el-form-item label="其他材料" prop="otherMaterialName" style="width:100%">
          <el-upload
              class="avatar-uploader"
              action="/service-center/api/v1/upload/file/single"
              :file-list="otherMaterialAttach"
              :limit="5"
              :headers="headers"
              :show-file-list="true"
              accept=".jpg,.jpeg,.png,.xlsx , .xls ,.docx,.dox,.pdf, .txt,.pptx , .JPG,.JPEG,.PBG,.GIF,.BMP,.PDF,.XLSX,.XLS ,.DOCX,.DOX ,.TXT , .PPTX"
              :on-remove="(file,fileList)=>handleRemoveFile(file,fileList,'otherMaterialAttach')"
              :on-error="handleFileError"
              :on-preview="handlePreview"
              :on-success="(e)=>handleFileSuccess(e,'otherMaterialAttach')"
          >
            <el-button size="small" type="primary" v-if="!disabled">上传附件</el-button>
          </el-upload>
<!--          <div v-for="(item,index) in otherMaterialAttach" class="file-list flex">-->
<!--            <span style="margin-right: 20px"> {{item.name}}</span>-->
<!--            <el-button size="mini" @click="openFile(item.path || item.url)">下载</el-button>-->
<!--          </div>-->
          <span class="red" v-if="otherMaterialAttach.length == 0">
            *单位认为需要提供的其他可以证明服务能力的材料
          </span>
        </el-form-item>
      </div>
    </el-form>
    <el-dialog :visible.sync="imgDialogVisible" class="img-dialog">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>


<script>
import {
  saveServiceProviderFifthInfo,
  sumbitServiceProviderAllInfo,
  getServiceProviderFifthInfo
} from "../../utils/interface";
import ningxia from "../../utils/ningxia";
import provinceData from "../../utils/provinceData";
const form = () => {
  return {
    awardCertificateName: "", // 获奖证书
    taxListName: "", // 税务登记证
    businessLicenseName: "", // 营业执照
    creditProofName: "", // 信用证明
    financialReportName: "", // 财务报表
    serviceSupportName: "", // 服务佐证材料
    achievementName: "", // 科研成果
    otherMaterialName: "", // 其他材料
  };
};
const rules = () => {
  return {
    awardCertificateName: [{ required: true, message: "请上传获奖证书", trigger: "blur" }],
    taxListName: [{ required: true, message: "请上传税务登记证", trigger: "blur" }],
    businessLicenseName: [{ required: true, message: "请上传营业执照", trigger: "blur" }],
    creditProofName: [{ required: true, message: "请上传信用证明", trigger: "blur" }],
    financialReportName: [{ required: true, message: "请上传财务报表", trigger: "blur" }],
    serviceSupportName: [{ required: true, message: "请上传服务佐证材料", trigger: "blur" }],
    achievementName: [{ required: true, message: "请上传科研成果", trigger: "blur" }],
  };
};
export default {
  name: "",
  components: {},
  props: {
    uuid: String,
    licenseUrl: String
  },
  data() {
    return {
      headers: {
        Authorization: "Bearer " + this.$cookies.get("api_access_token") //	可以是授权凭证用的参数值
      },
      businessLicenseAttach: [],
      creditProofAttach: [],
      taxListAttach: [],
      financialReportAttach: [],
      serviceSupportAttach: [],
      awardCertificateAttach: [],
      achievementAttach: [],
      otherMaterialAttach: [],
      dialogImageUrl: '',
      imgDialogVisible: false,
      form: form(),
      rules: rules(),
      regionOptions: provinceData,
      disabled: false,
      // uuid: ""
    };
  },
  watch: {},
  computed: {},
  created() {},
  mounted() {
    if (this.$route.query.uuid) {
      this.getServiceProviderFifthInfo(this.$route.query.uuid);
    }
    setTimeout(() => {
      console.log("licenseUrl",this.licenseUrl,this.businessLicenseAttach);
      if (this.businessLicenseAttach.length === 0) {
        this.businessLicenseAttach.push({
          name: "申报单位营业执照",
          url:this.licenseUrl
        });
        this.form.businessLicenseName = "申报单位营业执照";
      }
    },200)

  },
  methods: {
    // 文件预览功能
    handlePreview(file) {
      const url = file.url || file.path;
      if (url) {
        window.open(url, '_blank');
      }
    },
    openFile(url) {
      if (url) {
        window.open(url, '_blank');
      } else {
        this.$message.warning('文件地址无效');
      }
    },
    // 模板附件
    handleFileSuccess(res, file) {
      console.log("上传文件",file);
      // 根据不同的上传区域，将文件添加到对应的列表中
      if (file.includes("creditProof")) {
        this.creditProofAttach.push(res);
        this.form.creditProofName = res.name;
      } else if (file.includes("businessLicenseAttach")) {
        this.businessLicenseAttach.push(res);
        this.form.businessLicenseName = res.name;
      }else if (file.includes("taxList")) {
        this.taxListAttach.push(res);
        this.form.taxListName = res.name;
      } else if (file.includes("financialReport")) {
        this.financialReportAttach.push(res);
        this.form.financialReportName = res.name;
      } else if (file.includes("serviceSupport")) {
        this.serviceSupportAttach.push(res);
        this.form.serviceSupportName = res.name;
      } else if (file.includes("awardCertificate")) {
        this.awardCertificateAttach.push(res);
        this.form.awardCertificateName = res.name;
      } else if (file.includes("achievement")) {
        this.achievementAttach.push(res);
        this.form.achievementName = res.name;
      } else if (file.includes("otherMaterial")) {
        this.otherMaterialAttach.push(res);
        this.form.otherMaterialName = res.name;
      }
    },
    handlePictureCardPreview(file) {
      console.log("预览。。",file);
      this.dialogImageUrl = file.url;
      this.imgDialogVisible = true;
    },
    handleRemoveFile(file, fileList,name) {
      if (this.disabled) return;
      // 根据不同的上传区域，从对应的列表中移除文件
      if (name.includes("creditProof")) {
        this.creditProofAttach = fileList;
        console.log(fileList,!fileList)
        fileList.length === 0 && (this.form.creditProofName = "");
      } else if (name.includes("businessLicenseAttach")) {
        this.businessLicenseAttach = fileList;
        fileList.length === 0 && (this.form.businessLicenseName = "");
      } else if (name.includes("taxList")) {
        this.taxListAttach = fileList;
        fileList.length === 0 && (this.form.taxListName = "");
      } else if (name.includes("financialReport")) {
        this.financialReportAttach = fileList;
        fileList.length === 0 && (this.form.financialReportName = "");
      } else if (name.includes("serviceSupport")) {
        this.serviceSupportAttach = fileList;
        fileList.length === 0 && (this.form.serviceSupportName = "");
      } else if (name.includes("awardCertificate")) {
        this.awardCertificateAttach = fileList;
        fileList.length === 0 && (this.form.awardCertificateName = "");
      } else if (name.includes("achievement")) {
        this.achievementAttach = fileList;
        fileList.length === 0 && (this.form.achievementName = "");
      } else if (name.includes("otherMaterial")) {
        this.otherMaterialAttach = fileList;
      }
    },

    handleFileError(err, file, fileList) {
      this.$message.error(err);
    },
    /* 获取第四步详情 */
    getServiceProviderFifthInfo(uuid) {
      getServiceProviderFifthInfo({ unitUuid: uuid }).then(res => {
        if (res.success && res.data && Object.keys(res.data).length > 0) {
          this.form = res.data;
          this.businessLicenseAttach = res.data.businessLicenseAttach?res.data.businessLicenseAttach.map(item => ({
            name: item.name,
            url: item.url || item.path,
          })):[] || [];
          this.creditProofAttach = res.data.creditProofAttach || [];
          this.taxListAttach = res.data.taxListAttach || [];
          this.financialReportAttach = res.data.financialReportAttach || [];
          this.serviceSupportAttach = res.data.serviceSupportAttach || [];
          this.awardCertificateAttach = res.data.awardCertificateAttach || [];
          this.achievementAttach = res.data.achievementAttach || [];
          this.otherMaterialAttach = res.data.otherMaterialAttach || [];
          this.getRegion();
          this.disabled =
              this.$route.query.status == "1" ||
              this.$route.query.status == "4"
                  ? false
                  : true;
        } else {
          this.form = form();
        }
      });
    },
    /* 第四步保存 */
    async save(type) {
      await this.saveServiceProviderFifthInfo();
      if(type === 'submit') {
        this.sumbitServiceProviderAllInfo()
      }
      this.$router.push("/serviceProviderList");
    },
    /* 服务商应用保存 */
    saveServiceProviderFifthInfo() {
      return new Promise((resolve, reject) => {
        this.$refs.form.validate(valid => {
          if (valid) {
            // 将所有附件列表合并到 form 中
            this.form.creditProofAttach = this.creditProofAttach.map(item => ({
              path: item.url || item.path,
              name: item.name,
            }));
            this.form.businessLicenseAttach = this.businessLicenseAttach.map(item => ({
              path: item.url || item.path,
              name: item.name,
            }));
            this.form.taxListAttach = this.taxListAttach.map(item => ({
              path: item.url || item.path,
              name: item.name,
            }));
            this.form.financialReportAttach = this.financialReportAttach.map(item => ({
              path: item.url || item.path,
              name: item.name,
            }));
            this.form.serviceSupportAttach = this.serviceSupportAttach.map(item => ({
              path: item.url || item.path,
              name: item.name,
            }));
            this.form.awardCertificateAttach = this.awardCertificateAttach.map(item => ({
              path: item.url || item.path,
              name: item.name,
            }));
            this.form.achievementAttach = this.achievementAttach.map(item => ({
              path: item.url || item.path,
              name: item.name,
            }));
            this.form.otherMaterialAttach = this.otherMaterialAttach.map(item => ({
              path: item.url || item.path,
              name: item.name,
            }));

            console.log(this.form, this.uuid);
            saveServiceProviderFifthInfo({
              userUuid: this.$store.state.isUsermessage.uuid,
              unitUuid: this.$route.query.uuid || this.uuid,
              ...this.form,
            }).then(res => {
              if (res.success) {
                //this.uuid = res.data.uuid;
                resolve();
              } else {
                reject();
              }
            });
          }
        });
      });
    },
    /* 申报提交、保存 */
    sumbitServiceProviderAllInfo(type) {
      return new Promise((resolve, reject) => {
        sumbitServiceProviderAllInfo({uuid:this.$route.query.uuid || this.uuid}).then(res => {
          if (res.success) {
            this.$message({
              message: res.message,
              type: "success"
            });
            resolve();
          } else {
            this.$message({
              message: res.message,
              type: "error"
            });
            reject();
          }
        });
      });
    },
    /* 改变区市 */
    changeRegion(val) {
      if (val) {
        this.form.provice = val[0];
        this.form.city = val[1];
        this.form.area = val[2];
      } else {
        this.form.provice = "";
        this.form.city = "";
        this.form.area = "";
      }
    },
    /* 回显省/区/市 */
    getRegion() {
      this.form.regionValue = [
        this.form.provice,
        this.form.city,
        this.form.area
      ];
    }
  }
};

</script>
<style lang="less" scoped>
@import "../../assets/css/common.less";
/deep/ .el-upload-list__item .el-icon-close-tip {
  display: none !important;
}
.enterpriseInfo {
  min-height: 300px;
  margin-bottom: 35px;
  border-radius: 12px;
  .file-list{
    height: 30px;
    align-items: center;
  }
  .red{
    font-size: 12px;
  }
  .avatar-uploader{
    display: flex;
  }
  .form-wrap {
    padding: 10px 20px;
    .bs();

    p {
      font-size: 14px;
      color: #888888;
      line-height: 1.7;
      margin-bottom: 40px;
    }
    .w300 {
      width: 300px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/providerApply/attachInfo.vue